"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBaseUnit = exports.fromBaseUnit = exports.bnOrZero = exports.bn = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const bn = (n, base = 10) => new bignumber_js_1.default(n, base);
exports.bn = bn;
const bnOrZero = (n) => {
    const value = (0, exports.bn)(n || 0);
    return value.isNaN() ? (0, exports.bn)(0) : value;
};
exports.bnOrZero = bnOrZero;
const fromBaseUnit = (value, decimals, displayDecimals = 6) => {
    return (0, exports.bnOrZero)(value)
        .div(`1e+${decimals}`)
        .decimalPlaces(displayDecimals, bignumber_js_1.default.ROUND_DOWN)
        .toString();
};
exports.fromBaseUnit = fromBaseUnit;
const toBaseUnit = (amount, precision) => {
    return (0, exports.bnOrZero)(amount)
        .times(new bignumber_js_1.default(10).exponentiatedBy((0, exports.bnOrZero)(precision)))
        .toFixed(0);
};
exports.toBaseUnit = toBaseUnit;
